<!-- Sidebar -->
<ui-sidebar [items]="items()" [relativeUrl]="relativeUrl"></ui-sidebar>

<div #page class="ui-portal-page">
  <router-outlet></router-outlet>
</div>

<button class="btn-gray btn-scroll-up" ui-scroll-visibility="500" (click)="scrollTo()">
  <div class="ui-icon-arrow-down"></div>
</button>
